/* eslint-disable */

export interface CustomerTokenCreateDto {
  tokenName: string;
  scopes: string[];
  expiry: Date;
  clientId: string;
  customerId?: string | null;
}

export const fixCustomerTokenCreateDtoFromJson = (dto?: CustomerTokenCreateDto | null): void => {
  if (!dto) {
    return;
  }
  dto.expiry = dto.expiry && new Date(dto.expiry);
};

export const fixCustomerTokenCreateDtoToJson = (dto?: CustomerTokenCreateDto | null): void => {
  if (!dto) {
    return;
  }
};
